import * as React from 'react';
import { connect } from 'react-redux';

import { FiltersContainer } from '../../components/filters_container/filters_container';
import { TwoColumnContainer } from '../../components/two_column_container/two_column_container';

import { SeoContainer } from '../../components/seo_container/seo_container';
import { CommercialPromo } from '../../containers/commercial_promo/commercial_promo';
import { MagazineContainer } from '../../containers/magazine/magazine';
import { NewBuildingCaption } from '../../containers/new_building_caption/new_building_caption';
import { NewBuildingsServices } from '../../containers/new_buildings_service/new_buildings_services';
import { NewSeoUrlsWrapper } from '../../containers/new_seo_urls/new_seo_urls';
import { JKPopularList } from '../../containers/popular_jk/popular_jk';
import { PopularList } from '../../containers/popular_list/popular_list';
import { Promo } from '../../containers/promo/promo';
import { SaleServices } from '../../containers/sale_services/sale_services';
import { Filters } from '../../containers/search_block/filters';
import { SeoBlockContainer } from '../../containers/seo_block/seo_block';
import { Services } from '../../containers/services/services';
import { Specialists } from '../../containers/specialists/specialists';
import { VacanciesContainer } from '../../containers/vacancies/vacancies';
import { VerticalPromo } from '../../containers/vertical_promo/vertical_promo';
import { PropertyGuides } from '../../../shared/components/PropertyGuides';

import { RecommendedContainer } from '../../components/recommended_list';
import { getExperimentGroup } from '../../helpers/experiment_helpers';
import { getPropertyGuidesGroup } from '../../helpers/ab_mainpage_property_guides';
import { dealTypeFromJsonQuery } from '../../../shared/utils/category';
import { shouldNewFiltersShow } from '../../../shared/utils/filters';
import { shouldPropertyGuidesShow } from '../../../shared/utils/propertyGuides';
import { IReduxState } from '../../../shared/types/redux';
import { ITopJK, ITopThreeItem } from '../../models/top_three';
import { EPageKind } from '../../../shared/types/page';

interface IProps {
  pageKind: EPageKind;
  isFetching: boolean;
  top3?: ITopThreeItem[];
  popularJks?: ITopJK[];
  recommendationExperimentGroup: number | null;
  isPropertyGuidesVisible: boolean;
}

interface IHomeProps {
  section: string;
}

class HomeComponent extends React.Component<IProps & IHomeProps> {
  public renderPromo() {
    switch (this.props.section) {
    case 'index':
      return (<Promo/>);
    case 'daily-rent':
    case 'sale':
    case 'rent':
    case 'new-buildings':
      return (<VerticalPromo/>);
    case 'commercial':
      return (<CommercialPromo/>);
    default:
      return null;
    }
  }

  public renderServices() {
    switch (this.props.section) {
      case 'daily-rent':
      case 'commercial':
      case 'sale':
      case 'rent':
        return (<SaleServices/>);
      case 'new-buildings':
        return (<NewBuildingsServices/>);
      case 'index':
      default:
        return null;
    }
  }

  public renderPopular() {
    if (this.props.section === 'new-buildings') {
      return (
        <JKPopularList
          services={ this.renderServices() }
        />
      );
    } else {
      return (
        <PopularList
          showLinkToAll={ (this.props.section !== 'index') }
          services={ this.renderServices() }
        />
      );
    }
  }

  public render() {
    if (this.props.isFetching) {
      return null;
    }

    const { pageKind, section, recommendationExperimentGroup, isPropertyGuidesVisible } = this.props;
    const isIndexSection = section === 'index';
    const isRecommendationExperiment =
      recommendationExperimentGroup === 1
      || recommendationExperimentGroup === 2
      || recommendationExperimentGroup === 3;

    return (
      <div>
        <FiltersContainer>
          <NewBuildingCaption section={section} />
          <Filters section={section} />
        </FiltersContainer>

        {isPropertyGuidesVisible && <PropertyGuides pageKind={pageKind} />}

        { isIndexSection && isRecommendationExperiment &&
          <RecommendedContainer experimentGroup={recommendationExperimentGroup} />
        }

        { this.renderPromo() }

        <TwoColumnContainer
          wideRow={(section === 'commercial')}
          popularPresented={this.popularPresented()}
        >
          { this.renderPopular() }
          <Specialists
            section={section}
            popularPresented={this.popularPresented()}
          />
        </TwoColumnContainer>

        { isIndexSection &&
          <>
            <MagazineContainer />
            <VacanciesContainer />
            <Services />
          </>
        }

        <SeoContainer>
          <SeoBlockContainer />
          <NewSeoUrlsWrapper />
        </SeoContainer>
      </div>
    );
  }

  private popularPresented() {
    return (!!this.props.top3 && this.props.top3.length > 0) ||
            (!!this.props.popularJks && this.props.popularJks.length > 0);
  }
}

const mapStateToProps = ({ page, mainpage, config, type, filters }: IReduxState, { section }: IHomeProps): IProps => {
  const propertyGuidesExperimentGroup = getPropertyGuidesGroup(mainpage.experiments || []);

  const newSearchType = dealTypeFromJsonQuery(filters.jsonQuery);

  const isNewFiltersVisible = shouldNewFiltersShow({ section });

  const isPropertyGuidesVisible = shouldPropertyGuidesShow({
    filters: { isNewFiltersVisible, oldSearchType: type.searchType, newSearchType },
    section,
    subdomain: config.subdomain,
    experimentGroup: propertyGuidesExperimentGroup,
  });

  return {
    pageKind: page.kind,
    isFetching: mainpage.isFetching,
    top3: mainpage.top3,
    popularJks: mainpage.popularJks,
    recommendationExperimentGroup: getExperimentGroup(mainpage.experiments, 'newbuilding_recommendations'),
    isPropertyGuidesVisible,
  };
};

export const Home = connect<IProps, {}, IHomeProps>(mapStateToProps)(HomeComponent);
